import type { CSSProperties } from 'react'

export const alertContainerStyles: CSSProperties = {
  position: 'fixed',
  top: 'var(--space-lg)',
  right: 'var(--space-lg)',
  zIndex: 'var(--z-toast)' as unknown as number,
  width: '380px',
  maxWidth: 'calc(100vw - 2rem)',
  display: 'flex',
  flexDirection: 'column',
  gap: 'var(--space-xs)',
}

export const animationStyles = `
@keyframes alertSlideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
`
